export interface IConfirmationModalResponse {
  windowId?: string;
  okResponse: boolean;
}

export const DefaultConfirmationModalResponse: IConfirmationModalResponse = {
  okResponse: false,
};
